// 触觉反馈工具函数

/**
 * 触发设备振动反馈
 * @param {number} duration - 振动时长（毫秒）
 */
export const triggerHaptic = (duration = 15) => {
  if (typeof navigator !== 'undefined' && navigator.vibrate) {
    navigator.vibrate(duration);
  }
};

/**
 * 触发强烈振动反馈
 */
export const triggerStrongHaptic = () => {
  if (typeof navigator !== 'undefined' && navigator.vibrate) {
    navigator.vibrate([30, 50, 30]);
  }
};

/**
 * 触发成功振动反馈
 */
export const triggerSuccessHaptic = () => {
  if (typeof navigator !== 'undefined' && navigator.vibrate) {
    navigator.vibrate([10, 30, 10]);
  }
};

/**
 * 触发错误振动反馈
 */
export const triggerErrorHaptic = () => {
  if (typeof navigator !== 'undefined' && navigator.vibrate) {
    navigator.vibrate([50, 100, 50, 100, 50]);
  }
};
